import { render } from "./KitsAddView.vue?vue&type=template&id=21e178bf"
import script from "./KitsAddView.vue?vue&type=script&lang=js"
export * from "./KitsAddView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__